export const broadcastChannel = new BroadcastChannel('cache-invalidation');

export const broadcastCacheInvalidator = (cacheTags: any): any => {
  broadcastChannel.postMessage(cacheTags);
  return cacheTags;
};
